import React, { useState, useEffect, Component } from 'react'
import { useHistory, useLocation } from 'react-router-dom';
import ErrorOutlineRounded from '@material-ui/icons/ErrorOutlineRounded'
import CheckCircleOutline from '@material-ui/icons/CheckCircleOutline'
import axios, { AxiosResponse } from 'axios';
import Alert from '@material-ui/lab/Alert/Alert';
import DeleteIcons from '@material-ui/icons/Delete'
import ViewIcons from '@material-ui/icons/Visibility'
import { InsertarDocumentosLogic } from '../../../view-model/Documentos/Documentos.logic';
import { Button, Dialog, DialogActions, DialogContent } from '@material-ui/core'
import { CircularProgress, Grid, Link } from '@material-ui/core'; import { ObtieneDatosPersonalesLogic, ObtieneDatosTipoPersonaPorPostulacionLogic, useStyles } from '../../../view-model/DatosPersonales/DatosPersonales.logic';
import { ObtieneEtapaProcesoLogic, UpdateEtapaProcesoLogic, Link2, Link3 } from '../../../view-model/EtapasProceso/EtapasProceso.logic';
import { ObtieneEtapasLogic, ObtieneSiguienteEtapaLogic } from '../../../view-model/Inicio/PostulacionesEstudiante.logic';
import IViewEtapas from '../../../view-interfaces/IViewEtapas';
import { format } from 'fecha';
import IViewDocumentos from "../../../../presentation/view-interfaces/IViewDocumentos";
import { ObtieneContratoLogic, eCert_firmaLogic, ObtieneFirmaLogic, ObtieneContratoWebLogic, EstadoFirmaEcertLogic, QuitarContratoManualLogic, BajarContratoManualLogic, ObtieneExcepcionLogic, ObtieneExcepcionProgramaLogic } from '../../../view-model/Contrato/Contrato.logic';
import { Element } from 'domhandler';
import IcartPopUp from '../../../view-model/Modals/Ecert';
import { getDate } from 'date-fns';
import { useDocument, useWindow } from '@fluentui/react-window-provider';
import { con } from "../../../../application/entity/Rutas";
import queryString from 'query-string';
import logoUDD from '../../../../assets/svg/logo-udd-blanco.svg';
import { InsertPrimeraEtapaProcesoFirmaLogic } from '../../../view-model/EtapasProceso/EtapasProceso.logic';
import IViewPersona from '../../../view-interfaces/IViewPersona';
import { ActualizarEstadoRefirmaLogic, DatosRefirmaPorIdLogic } from '../../../view-model/ReFirma/ReFirma.logic';
import parse from 'html-react-parser';
import IViewParametros from '../../../view-interfaces/IViewParametros';
import { ObtieneParametrosLogic } from '../../../view-model/Parametros/Parametros.logic';
import MensajeToken from '../../../../Components/MensajeToken/MensajeToken';

const OnlyFirmaContrato = () => {

    const history = useHistory();
    const location = useLocation();

    const win = useWindow();
    const doc = useDocument();
    const [validado, setValidado] = useState(0);
    const [openIFrame, setOpenIFrame] = useState(false);
    const [openRespuesta, setOpenRespuesta] = useState(false);

    const [postulante, setPostulante] = useState([]);
    const [representanteFinanciero, setRepresentanteFinanciero] = useState([]);
    const [asegurado, setAsegurado] = useState([]);
    const [contacto, setContacto] = useState([]);
    const [tutorLegal, setTutorLegal] = useState([]);

    const [loading, setLoading] = useState(false);

    const [rutAlumno, setRutAlumno] = useState(0);
    const [numeroAlumno, setNumeroAlumno] = useState('');
    const [añoPromocion, setAñoPromocion] = useState(0);
    const [periodoPromocion, setPeriodoPromocion] = useState(0);
    const [ok, setOk] = useState('');

    const listaEtapas: Array<IViewEtapas> = [];

    const [cargandoValores, setCargandoValores] = useState(true)

    const [cargandoContrato, setCargandoContrato] = useState(false)

    const [error, setError] = useState(false)
    const [reintentar, setReintentar] = useState(false)
    const [tieneExcepcion, setTieneExcepcion] = useState(false)
    const Doc: Array<IViewDocumentos> = [];
    const [cod, setCod] = useState(0)

    const [errorVentanasEmergentes, setErrorVentanasEmergentes] = useState(false)
    const [errorEtapas, setErrorEtapas] = useState(false)

    const [mnsjeCert, setMnsjeCert] = useState(con.mnsjeCert())

    const [anoProm, setAnoProm] = useState(0)
    const [codigoNegocio, setcodigoNegocio] = useState(0)
    const [codCarrera, setcodCarrera] = useState('')
    const [semestreProm, setsemestreProm] = useState(0)
    const [codPlanificacion, setCodPlanificacion] = useState(0)
    const [idProcesoPostulante, setIdProcesoPostulante] = useState(0);
    const [numAlumno, setNumAlumno] = useState('')
    const [firmaCompleta, setFirmaCompleta] = useState(false)
    const [validarFirmas, setValidarFirmas] = useState(false)

    const firmas: any = [];
    const [listadoFirmas, setListadoFirmas] = useState(firmas);
    const [esMenorEdad, setEsMenorEdad] = useState(false);

    const [buscarAlumno, setBuscarAlumno] = useState(false);

    const [errorData, setErrorData] = useState(false)
    const [iRF, setIRF] = useState('')

    const [iFA, setIFA] = useState('');

    const [iFR, setIFR] = useState('');

    const [idRefirma, setIdRefirma] = useState(0)
    const [idTipoFirmando, setIdTipoFirmando] = useState(0);
    const [openModalToken, setOpenModalToken] = useState({ open: false, mnsj: "" })
  const [codNegocio, setCodNegocio] = useState(0)

    useEffect(() => {
        let url = window.location.href;
        if (url.indexOf('?') !== -1) {
            var param = queryString.parse(window.location.search);
            localStorage.setItem("IdRefirma", param.id!.toString())
            setIdRefirma(parseInt(param.id!.toString()))
            DatosRefirmaPorIdLogic(selListaPersona, parseInt(param.id!.toString()));
        } else {
            history.push({
                pathname: "/Inicio"
            });
        }
    }, [])
    const selPrimeraEtapa = (error: Boolean, err: string, data: any) => {
        if (error === false && data !== undefined) {
            setIdProcesoPostulante(parseInt(data))
        }
    }

    /*  useEffect(() => {
         if (check1 && check2 && !openRespuesta) {
             ObtenerListadoDocumentos();
             setFirmaCompleta(true)
         }
 
     }, [firmado1, firmado2, openRespuesta]) */

    const selListaCambioEstado = (
        error: Boolean, err: string, result: any) => {
        try {
            if (error === false && result.length > 0) {
                setFirmaCompleta(result == "Registros actualizados")
            }
            setValidarFirmas(false)
        } catch (er) {
            setValidarFirmas(false)
            setFirmaCompleta(false)
            console.log('error', er)
        }
    }

    const selListaPostulante = (error: Boolean, err: string, Estudiante: any) => {
        try {
            console.log(Estudiante)
            if (error === false && Estudiante.length > 0) {
                let _postulante: any = [];
                _postulante.rut = Estudiante[0].run;
                _postulante.dv = Estudiante[0].dv;
                _postulante.nombres = Estudiante[0].nombres;
                _postulante.apPaterno = Estudiante[0].primerApellido;
                _postulante.apMaterno = Estudiante[0].segundoApellido;
                _postulante.fechaNacimiento = format(new Date(Estudiante[0].fechaNacimiento), 'YYYY-MM-DD');
                _postulante.idGenero = Estudiante[0].codSexo;
                _postulante.genero = Estudiante[0].sexo.trim();
                _postulante.telefono = Estudiante[0].telefono;
                _postulante.mail = Estudiante[0].email.trim();
                _postulante.direccion = Estudiante[0].direccion.trim();
                _postulante.idComuna = Estudiante[0].codigoComuna;
                _postulante.comuna = Estudiante[0].nombreComuna.trim();
                _postulante.idPais = Estudiante[0].idPais;
                _postulante.nacionalidad = Estudiante[0].nacionalidad.trim();
                _postulante.idTipoPersona = 1
                _postulante.idPersona = Estudiante[0].idPersona
                _postulante.nombreCompleto = Estudiante[0].nombreCompleto
                _postulante.rutCompleto = Estudiante[0].runFormato
                setEsMenorEdad(Estudiante[0].esMenorEdad)
                setBuscarAlumno(true)
                setPostulante(_postulante);

                setBuscarAlumno(true)
            }

        } catch (error) {
            console.log('error', error);
        }
    }

    useEffect(() => {
        if (codigoNegocio != 0 && idProcesoPostulante != 0 && buscarAlumno && idRefirma != 0) {
            let idPeriodo = 0;
            ObtieneFirmaLogic(selObtenerFirma, codigoNegocio, idProcesoPostulante, idPeriodo, esMenorEdad, idRefirma);
        }
    }, [codigoNegocio, idProcesoPostulante, buscarAlumno, esMenorEdad])

    const selListaPersona = (
        error: Boolean, err: string, persona: any) => {
        try {
            let _tt = JSON.stringify(location.state);
            let _params = JSON.parse(_tt);
            console.log(persona)
            if (error === false && persona.status) {
                setErrorData(false)
                const _rutAlumno: number = persona.rutAlumno;
                const _status: boolean = persona.status;
                const _codNegocio: number = 1;
                const _codCarrera: string = persona.codCarrera;
                const _anioProc: number = 2023;
                const _periodoProc: number = 1;
                const _numAlumno: string = "";

                setRutAlumno(_rutAlumno)
                setcodigoNegocio(_codNegocio);
                setcodCarrera(_codCarrera);
                setAnoProm(_anioProc);
                setAñoPromocion(_anioProc);
                setsemestreProm(_periodoProc);
                setPeriodoPromocion(_periodoProc);
                setCod(con.codDocumentoContrato());
                setNumAlumno(_numAlumno)
                InsertPrimeraEtapaProcesoFirmaLogic(selPrimeraEtapa, _rutAlumno, _anioProc, _periodoProc, 1, _codCarrera, 0)
                let idPeriodo = 0;
                console.log("ObtieneDatosTipoPersonaPorPostulacionLogic")
                setTimeout(() => {
                    ObtieneDatosPersonalesLogic(selListaPostulante, _params.headers, _rutAlumno, "", _codNegocio, 1, idPeriodo);
                }, 5000)

                setCod(con.codDocumentoContrato());
            } else {
                setErrorData(true)
            }
        } catch (er) {
            console.log('error', er)
            setErrorData(true)
        }
    }

    const selListaRepresentanteFinanciero = (
        error: Boolean, err: string, list: any) => {
        try {
            console.log(list)
            if (error === false && list.length > 0) {
                let _postulante: any = [];
                _postulante.rut = list[0].run;
                _postulante.dv = list[0].dv;
                _postulante.nombres = list[0].nombres;
                _postulante.apPaterno = list[0].primerApellido;
                _postulante.apMaterno = list[0].segundoApellido;
                _postulante.fechaNacimiento = format(new Date(list[0].fechaNacimiento), 'YYYY-MM-DD');
                _postulante.idGenero = list[0].codSexo;
                _postulante.genero = list[0].sexo.trim();
                _postulante.telefono = list[0].telefono;
                _postulante.mail = list[0].email.trim();
                _postulante.direccion = list[0].direccion.trim();
                _postulante.idComuna = list[0].codigoComuna;
                _postulante.comuna = list[0].nombreComuna.trim();
                _postulante.idPais = list[0].idPais;
                _postulante.nacionalidad = list[0].nacionalidad.trim();
                _postulante.idTipoPersona = 2
                _postulante.idPersona = list[0].idPersona
                _postulante.nombreCompleto = list[0].nombreCompleto
                _postulante.rutCompleto = list[0].runFormato

                setRepresentanteFinanciero(_postulante);
            } else {
                if (err != "500") {
                    setOpenModalToken({ open: true, mnsj: err })
                }
            }
        } catch (er) {
            console.log('error', er)
        }
    }

    const selListaAsegurado = (
        error: Boolean, err: string, list: any) => {
        try {
            if (error === false && list.length > 0) {
                let _postulante: any = [];
                _postulante.rut = list[0].run;
                _postulante.dv = list[0].dv;
                _postulante.nombres = list[0].nombres;
                _postulante.apPaterno = list[0].primerApellido;
                _postulante.apMaterno = list[0].segundoApellido;
                _postulante.fechaNacimiento = format(new Date(list[0].fechaNacimiento), 'YYYY-MM-DD');
                _postulante.idGenero = list[0].codSexo;
                _postulante.genero = list[0].sexo.trim();
                _postulante.telefono = list[0].telefono;
                _postulante.mail = list[0].email.trim();
                _postulante.direccion = list[0].direccion.trim();
                _postulante.idComuna = list[0].codigoComuna;
                _postulante.comuna = list[0].nombreComuna.trim();
                _postulante.idPais = list[0].idPais;
                _postulante.nacionalidad = list[0].nacionalidad.trim();
                _postulante.idTipoPersona = 3
                _postulante.idPersona = list[0].idPersona
                _postulante.nombreCompleto = list[0].nombreCompleto
                _postulante.rutCompleto = list[0].runFormato

                setAsegurado(_postulante);
            } else {
                if (err != "500") {
                    setOpenModalToken({ open: true, mnsj: err })
                }
            }
        } catch (er) {
            console.log('error', er)
        }
    }

    const selListaContacto = (
        error: Boolean, err: string, list: any) => {
        try {
            if (error === false && list.length > 0) {
                let _postulante: any = [];
                _postulante.rut = list[0].run;
                _postulante.dv = list[0].dv;
                _postulante.nombres = list[0].nombres;
                _postulante.apPaterno = list[0].primerApellido;
                _postulante.apMaterno = list[0].segundoApellido;
                _postulante.fechaNacimiento = format(new Date(list[0].fechaNacimiento), 'YYYY-MM-DD');
                _postulante.idGenero = list[0].codSexo;
                _postulante.genero = list[0].sexo.trim();
                _postulante.telefono = list[0].telefono;
                _postulante.mail = list[0].email.trim();
                _postulante.direccion = list[0].direccion.trim();
                _postulante.idComuna = list[0].codigoComuna;
                _postulante.comuna = list[0].nombreComuna.trim();
                _postulante.idPais = list[0].idPais;
                _postulante.nacionalidad = list[0].nacionalidad.trim();
                _postulante.idTipoPersona = 4
                _postulante.idPersona = list[0].idPersona
                _postulante.nombreCompleto = list[0].nombreCompleto
                _postulante.rutCompleto = list[0].runFormato

                setContacto(_postulante);
            } else {
                if (err != "500") {
                    setOpenModalToken({ open: true, mnsj: err })
                }
            }
        } catch (er) {
            console.log('error', er)
        }
    }

    const selListaTutorLegal = (
        error: Boolean, err: string, list: any) => {
        try {
            if (error === false && list.length > 0) {
                let _postulante: any = [];
                _postulante.rut = list[0].run;
                _postulante.dv = list[0].dv;
                _postulante.nombres = list[0].nombres;
                _postulante.apPaterno = list[0].primerApellido;
                _postulante.apMaterno = list[0].segundoApellido;
                _postulante.fechaNacimiento = format(new Date(list[0].fechaNacimiento), 'YYYY-MM-DD');
                _postulante.idGenero = list[0].codSexo;
                _postulante.genero = list[0].sexo.trim();
                _postulante.telefono = list[0].telefono;
                _postulante.mail = list[0].email.trim();
                _postulante.direccion = list[0].direccion.trim();
                _postulante.idComuna = list[0].codigoComuna;
                _postulante.comuna = list[0].nombreComuna.trim();
                _postulante.idPais = list[0].idPais;
                _postulante.nacionalidad = list[0].nacionalidad.trim();
                _postulante.idTipoPersona = 5
                _postulante.idPersona = list[0].idPersona
                _postulante.nombreCompleto = list[0].nombreCompleto
                _postulante.rutCompleto = list[0].runFormato

                setTutorLegal(_postulante);
            } else {
                if (err != "500") {
                    setOpenModalToken({ open: true, mnsj: err })
                }
            }
        } catch (er) {
            console.log('error', er)
        }
    }

    const handleVisualizarContrato = () => {
        setCargandoContrato(true)
        let idPeriodo = 0;
        let _tt = JSON.stringify(location.state);
        let _params = JSON.parse(_tt);
        //ObtieneContratoLogic(selResultadoContrato, codigoNegocio, codCarrera, rutAlumno, false, añoPromocion, codPlanificacion, false, idPeriodo, idPersona);
        ObtieneContratoLogic(selResultadoContrato, _params.headers, codigoNegocio, codCarrera, rutAlumno, false, añoPromocion, codPlanificacion, false, idPeriodo, 0);
    }
    const handleVisualizarContratoConFirma = () => {
        setCargandoContrato(true)
        let idPeriodo = 0;
        let _tt = JSON.stringify(location.state);
        let _params = JSON.parse(_tt);
        //ObtieneContratoLogic(selResultadoContrato, codigoNegocio, codCarrera, rutAlumno, false, añoPromocion, codPlanificacion, true, idPeriodo, idPersona);
        ObtieneContratoLogic(selResultadoContrato, _params.headers, codigoNegocio, codCarrera, rutAlumno, false, añoPromocion, codPlanificacion, true, idPeriodo, 0);
    }
    const handleFirmaContrato = (idTipoPersona: number) => {
        let idPeriodo = 0;
        setIdTipoFirmando(idTipoPersona);
        setOpenIFrame(true);
        eCert_firmaLogic(selResultadoFirma, idProcesoPostulante, 18961013/* ObtenerPersonaPorID(idTipoPersona, "rut") */, añoPromocion, periodoPromocion, numeroAlumno, idTipoPersona, idPeriodo);
    }

    const selResultadoContrato = (error: Boolean, err: string, Resultado: any) => {
        try {
            if (error === false) {
                setCargandoContrato(false)
            } else {
                if (err != "500") {
                    setOpenModalToken({ open: true, mnsj: err })
                }
            }
        } catch (err) {
            console.log('error', err)
        }

    }
    const selResultadoEstadoEcert = (error: Boolean, err: string, Resultado: any) => {
        try {
        } catch (err) {
            console.log('error', err)
        }

    }
    const selResultadoFirma = (error: Boolean, err: string, Resultado: any) => {
        try {
            if (error === false) {
                if (Resultado.token !== "") {
                    let url = (Resultado.url + "?Token=" + Resultado.token)
                    let windowName = 'w_' + Date.now() + Math.floor(Math.random() * 100000).toString();
                    var form = document.createElement("form");
                    form.setAttribute("method", "post");
                    form.setAttribute("action", url);

                    form.setAttribute("target", windowName);

                    var respuesta = window.open(url);

                    var timer = setInterval(function () {
                        try {
                            if (respuesta!.closed) {
                                let idPeriodo = 0;
                                //ObtieneFirmaLogic(selObtenerFirma, codigoNegocio, idProcesoPostulante, idPeriodo, esMenorEdad);
                                ObtieneFirmaLogic(selObtenerFirma, codigoNegocio, idProcesoPostulante, idPeriodo, esMenorEdad, idRefirma);
                                clearInterval(timer);
                            }
                        }
                        catch (e: any) {
                            setErrorVentanasEmergentes(true)
                        }

                    }, 500);
                    form.submit();
                } else {
                    setErrorEtapas(true)
                    setOpenIFrame(false)
                }
            }
        } catch (err) {
            console.log('error', err)
        }
    }

    const selObtenerFirma = (error: Boolean, err: string, Resultado: any) => {
        try {
            let _tt = JSON.stringify(location.state);
            let _params = JSON.parse(_tt);
            if (error === false) {
                ObtieneParametrosLogic(selListaParametrosIFR, 'IFR')
                ObtieneParametrosLogic(selListaParametrosIFA, 'IFA')
                setListadoFirmas(Resultado)
                let idPeriodo = 0;
                let listadoFirmados: any;
                let _firmaCompleta: boolean = false;

                listadoFirmados = Resultado.filter((w: any) => w.contratoFirmado);
                _firmaCompleta = listadoFirmados.lenght == Resultado.lenght;
                setValidarFirmas(_firmaCompleta)
                if (_firmaCompleta) {
                    const _idRefirma: any = localStorage.getItem("IdRefirma")
                    setValidarFirmas(true)
                    ActualizarEstadoRefirmaLogic(selListaCambioEstado, parseInt(_idRefirma), 2, "MATWEB");
                } else {
                    Resultado.map((e: any) => {
                        if (e.idTipoPersona === 2) {
                            ObtieneDatosTipoPersonaPorPostulacionLogic(selListaRepresentanteFinanciero, _params.headers, rutAlumno, codigoNegocio, codCarrera, anoProm, periodoPromocion, 0, 2, idPeriodo, idRefirma);
                        } else if (e.idTipoPersona === 3) {
                            ObtieneDatosTipoPersonaPorPostulacionLogic(selListaAsegurado, _params.headers, rutAlumno, codigoNegocio, codCarrera, anoProm, periodoPromocion, 0, 3, idPeriodo, idRefirma);
                        } else if (e.idTipoPersona === 4) {
                            ObtieneDatosTipoPersonaPorPostulacionLogic(selListaContacto, _params.headers, rutAlumno, codigoNegocio, codCarrera, anoProm, periodoPromocion, 0, 4, idPeriodo, idRefirma);
                        } else if (e.idTipoPersona === 5) {
                            ObtieneDatosTipoPersonaPorPostulacionLogic(selListaTutorLegal, _params.headers, rutAlumno, codigoNegocio, codCarrera, anoProm, periodoPromocion, 0, 5, idPeriodo, idRefirma);
                        }
                    })
                }

                setCargandoValores(false)
            } else {
                setError(true)
            }
        } catch (err) {
            console.log('error', err)
        }
    }

    useEffect(() => {
        setLoading(true);
        setCargandoValores(true)
        setLoading(false);
    }, [rutAlumno])

    /* useEffect(() => {
        let idPeriodo = 0;
        ObtieneFirmaLogic(selObtenerFirma, codigoNegocio, idProcesoPostulante, idPeriodo, esMenorEdad);
    }, [idProcesoPostulante]) */


    const selUpdateEtapa = (error: Boolean, err: string, data: any) => {
        if (error === false && data !== undefined) {
            //console.log(data)
            /* onClickContinuar('7') */
        }
    }

    const ObtenerListadoDocumentos = () => {
        var alumnoFirma = queryString.parse(window.location.search);
        setTimeout(() => {
            ObtieneContratoWebLogic(selListaManual, rutAlumno, codCarrera)
        }, 3000)

    }

    const selListaManual = (error: Boolean, err: string, result: any) => {
        if (error === false) {
            if (result.length > 0) {
                InsertarDocumentos(4, 'PDF', result)
            }
        }
    }
    const InsertarDocumentos = (idDoc: number, extension: string, base64: string) => {
        let idPeriodo = 0;
        var alumnoFirma = queryString.parse(window.location.search);
        //InsertarDocumentosLogic(selInsertDocumentos, 1, parseInt(alumnoFirma.rut!.toString()), alumnoFirma.codprograma!.toString(), "MATWEB", idDoc, extension, base64, 0, 0, 1, _params.CodigoPlanificacionAcademica, idPeriodo, idPersona)
        InsertarDocumentosLogic(selInsertDocumentos, 1, parseInt(alumnoFirma.rut!.toString()), alumnoFirma.codprograma!.toString(), "MATWEB", idDoc, extension, base64, 0, 0, 1, 0, idPeriodo, 0)
    }
    const selInsertDocumentos = (error: Boolean, err: string, result: boolean) => {
        if (error === false && result !== undefined) {
        } else {
        }
    }

    const classes = useStyles();

    const ObtenerPersonaPorID = (idTipoPersona: number, valor: string) => {
        let _persona: any = [];
        console.log(postulante, representanteFinanciero, asegurado, contacto, tutorLegal)
        if (idTipoPersona == 1) {
            _persona = postulante;
        } else if (idTipoPersona == 2) {
            _persona = representanteFinanciero;
        } else if (idTipoPersona == 3) {
            _persona = asegurado;
        } else if (idTipoPersona == 4) {
            _persona = contacto;
        } else if (idTipoPersona == 5) {
            _persona = tutorLegal;
        }
        console.log(_persona, idTipoPersona, valor)
        if (_persona.rut != 0) {
            return _persona[valor];
        } else {
            return '';
        }
    }
    const firmaEnOrdenHabilitado = (idTipoPersona: number, index: number) => {
        if (index == 0) {
            return true
        } else {
            listadoFirmas.map((_e: any, _index: number) => {
                if (_index == (index - 1)) {
                    return _e.contratoFirmado
                }
            })
        }
    }

    const selListaParametrosIFA = (error: boolean, err: string, Parametro: IViewParametros[]) => {
        try {
            if (error === false && Parametro[0].sValor != "") {
                setIFA(Parametro[0].sValor);
            }
        } catch (err) {
            console.log('error', err);
        }
    }

    const selListaParametrosIFR = (error: boolean, err: string, Parametro: IViewParametros[]) => {
        try {
            if (error === false && Parametro[0].sValor != "") {
                setIFR(Parametro[0].sValor);
            }
        } catch (err) {
            console.log('error', err);
        }
    }

    return (
        <>
            {
                validarFirmas ?
                    <div className="site-main__container">
                        <div style={{ textAlign: 'center', marginTop: 100 }}>

                            <CircularProgress disableShrink />
                            <br />
                            <a><span>Validando firmas</span></a>

                        </div>
                    </div>
                    :
                    firmaCompleta ?
                        <>
                            <header style={{ position: 'fixed', display: 'grid', zIndex: 99 }} className="site-header">
                                <title>Matrícula Web Universidad Del Desarrollo</title>
                                <meta name='description' content='Proceso de Matrícula Web Universidad Del Desarrollo.'></meta>
                                <div className="site-header__container2">
                                    <div style={{ display: 'flex' }}>
                                        <div>
                                            <img style={{ marginLeft: '2rem', marginTop: '1rem' }} src={logoUDD} alt="Logo Universidad de Desarrollo" className="site-header__logo" />
                                        </div>
                                    </div>
                                </div>
                            </header>

                            <br></br>
                            <br></br>
                            <br></br>
                            <div style={{ textAlign: 'center', padding: 100 }}>
                                <CheckCircleOutline style={{ fontSize: 80, color: '#0062a1' }} />
                                <br />
                                <br />
                                <h3><span>Firmas realizadas exitosamente.</span></h3>
                            </div>
                        </>
                        :
                        <>
                            <header style={{ position: 'fixed', display: 'grid', zIndex: 99 }} className="site-header">
                                <title>Matrícula Web Universidad Del Desarrollo</title>
                                <meta name='description' content='Proceso de Matrícula Web Universidad Del Desarrollo.'></meta>
                                <div className="site-header__container2">
                                    <div style={{ display: 'flex' }}>
                                        <div>
                                            <img style={{ marginLeft: '2rem', marginTop: '1rem' }} src={logoUDD} alt="Logo Universidad de Desarrollo" className="site-header__logo" />
                                        </div>
                                    </div>
                                </div>
                            </header>

                            <br></br>
                            <br></br>
                            <br></br>
                            {
                                errorData ?
                                    <div className="site-main__container">
                                        <div className="enrollment__title">Firma de contrato</div>
                                        <div style={{ marginBottom: '2rem', color: 'gray', fontSize: 12 }}>
                                            <div className="enrollment__subtitle"></div>
                                        </div>
                                        <div style={{ textAlign: 'center', marginTop: 100, display: 'grid' }}>

                                            <ErrorOutlineRounded style={{ fontSize: 50, color: 'red', justifySelf: 'center' }} />
                                            <br />
                                            <a><span>Su solicitud ya fue realizada, o expiró</span></a>
                                            <a><span>Si tiene alguna duda comuniquese con la universidad</span></a>
                                            <a><span>800 200 125</span></a>
                                            <br />
                                        </div>
                                    </div>
                                    :
                                    error ?
                                        <div className="site-main__container">
                                            <div className="enrollment__title">Firma de contrato</div>
                                            <div style={{ marginBottom: '2rem', color: 'gray', fontSize: 12 }}>
                                                <div className="enrollment__subtitle"></div>
                                            </div>
                                            <div style={{ textAlign: 'center', marginTop: 100 }}>

                                                <ErrorOutlineRounded style={{ fontSize: 50, color: 'red' }} />
                                                <br />
                                                <a><span>Ocurrió un problema al obtener tus firmas, favor comunicarse con la universidad.</span></a>
                                                <br />
                                                <Button style={{ border: '1px solid gray' }} onClick={() => setReintentar(true)} color="inherit">Reintentar cargar firmas</Button>
                                            </div>
                                        </div>
                                        :
                                        <main className="site-main enrollment">
                                            {cargandoValores ?
                                                <div className="site-main__container">
                                                    <div style={{ textAlign: 'center', marginTop: 100 }}>

                                                        <CircularProgress disableShrink />
                                                        <br />
                                                        <a><span>Cargando datos</span></a>

                                                    </div>
                                                </div>
                                                :
                                                <div className="site-main__container">
                                                    <div className="enrollment__title">Firma de contrato</div>
                                                    <div style={{ marginBottom: '2rem', color: 'gray', fontSize: '1rem' }}>
                                                        <div className="enrollment__subtitle" style={{ display: "grid" }}>
                                                            {
                                                                listadoFirmas.length > 1 ?
                                                                    parse(iFR)
                                                                    :
                                                                    parse(iFA)
                                                            }
                                                        </div>
                                                    </div>
                                                    <div className={classes.root}>
                                                        <Grid container spacing={3} direction="column">
                                                            <Grid container item xs={12} direction="row">
                                                                <div>
                                                                    <Grid container>
                                                                        <Grid item xs={12}>
                                                                            1.- Visualizar contrato
                                                                        </Grid>
                                                                    </Grid>
                                                                </div>

                                                            </Grid>
                                                        </Grid>
                                                        <Grid container spacing={3} direction="column">
                                                            <Grid container item xs={12} direction="row">
                                                                <div>
                                                                    <Grid container>
                                                                        <Grid item xs={12}>
                                                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<Button
                                                                                className="printing-documents__download-btn"
                                                                                variant="contained"
                                                                                onClick={handleVisualizarContrato}
                                                                                color="primary"
                                                                                disabled={cargandoContrato}
                                                                                style={{ width: '13rem' }}
                                                                            >
                                                                                {cargandoContrato ? <CircularProgress color="inherit" size={20} disableShrink /> : "Visualizar contrato"}
                                                                            </Button>
                                                                        </Grid>
                                                                    </Grid>
                                                                </div>
                                                            </Grid>
                                                        </Grid>
                                                        <br />
                                                        <Grid container spacing={3} direction="column">
                                                            {loading && (<CircularProgress size={40} className={classes.buttonProgress} />)}



                                                            <Grid container item xs={12} direction="row" justifyContent="center" alignItems="stretch">
                                                                <Grid container>
                                                                    <Grid item xs={12}>
                                                                        2.- Firmas
                                                                    </Grid>
                                                                </Grid>
                                                            </Grid>
                                                            {
                                                                tieneExcepcion ?
                                                                    <p style={{ marginLeft: 40 }}>
                                                                        <p>Pasos a seguir:</p>
                                                                        <p style={{ marginLeft: 10 }}>1.- <strong>Descargar contrato.</strong></p>
                                                                        <p style={{ marginLeft: 10 }}>2.- <strong>Firmar contrato manualmente.</strong></p>
                                                                        <p style={{ marginLeft: 10 }}>3.- <strong>Escanear documento.</strong></p>
                                                                        <p style={{ marginLeft: 10 }}>4.- <strong>Cargar documento en formato PDF.</strong></p>
                                                                        <p style={{ marginLeft: 10 }}>5.- <strong>El contrato firmado manualmente debe ser entregado en original en la Oficina de Matrícula de la sede respectiva.</strong></p>
                                                                    </p>
                                                                    :
                                                                    ""
                                                            }
                                                            {
                                                                listadoFirmas.map((e: any, index: number) => {
                                                                    return (
                                                                        <>
                                                                            <Grid container item xs={12} direction="row" justifyContent="center" alignItems="stretch">
                                                                                <Grid container>
                                                                                    <Grid item xs={1}>
                                                                                        <div style={{ float: 'right' }}>
                                                                                            {e.contratoFirmado ? <CheckCircleOutline style={{ color: '#0062a1' }} /> : ""}
                                                                                        </div>
                                                                                    </Grid>
                                                                                    <Grid item xs={11} >
                                                                                        {
                                                                                            !firmaEnOrdenHabilitado(e.idTipoPersona, index) || e.contratoFirmado ?
                                                                                                <h5 style={{ fontSize: '1rem', color: 'gray', fontWeight: 400 }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Firma: {ObtenerPersonaPorID(e.idTipoPersona, "rutCompleto")} / {ObtenerPersonaPorID(e.idTipoPersona, "nombreCompleto")}</h5>
                                                                                                :
                                                                                                <div>
                                                                                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                                                                    <Link style={{ cursor: 'pointer' }} onClick={() => handleFirmaContrato(e.idTipoPersona)} >
                                                                                                        Firma : {ObtenerPersonaPorID(e.idTipoPersona, "rutCompleto")} / {ObtenerPersonaPorID(e.idTipoPersona, "nombreCompleto")}
                                                                                                    </Link>
                                                                                                </div>
                                                                                        }
                                                                                    </Grid>
                                                                                </Grid>
                                                                            </Grid>
                                                                        </>

                                                                    )
                                                                })
                                                            }
                                                            <Grid container item xs={10} direction="row-reverse" justifyContent="space-evenly" alignItems="stretch">
                                                                <div className="printing-documents__upload">
                                                                </div>
                                                            </Grid>
                                                        </Grid>
                                                    </div>
                                                </div>}

                                        </main>}
                            <div>
                                <Dialog open={openIFrame}
                                    onClose={() => setOpenIFrame(false)}
                                    maxWidth={"xl"}
                                    aria-labelledby="draggable-dialog-title">
                                    <DialogContent>
                                        <div style={{ fontFamily: 'sans-serif', textAlign: 'center' }}>
                                            {
                                                <div style={{ textAlign: 'center', padding: 20 }}>
                                                    <CircularProgress disableShrink />
                                                    <br />
                                                    <br />
                                                    <h4><span>Realizando firma eCert {ObtenerPersonaPorID(idTipoFirmando, "nombreCompleto")}.</span></h4>
                                                    <br />
                                                </div>
                                            }
                                        </div>
                                    </DialogContent>
                                </Dialog>
                                <Dialog open={openRespuesta}
                                    onClose={() => setOpenRespuesta(false)}
                                    aria-labelledby="draggable-dialog-title">
                                    <DialogContent>
                                        <div style={{ fontFamily: 'sans-serif', textAlign: 'center' }}>
                                            {ok === '0' ?
                                                <div style={{ textAlign: 'center', padding: 100 }}>

                                                    <CheckCircleOutline style={{ fontSize: 100, color: '#0062a1' }} />
                                                    <br />
                                                    <h1><span>Servicio</span></h1>
                                                    <h3><span>Su firma se ha registrado correctamente.</span></h3>

                                                </div>
                                                :
                                                <div style={{ textAlign: 'center', padding: 50 }}>

                                                    <ErrorOutlineRounded style={{ fontSize: 100, color: 'red' }} />
                                                    <br />
                                                    <h3><span>No hemos podido validar su identidad.</span></h3>
                                                    <p>Por favor descargar Contrato Prestación de Servicios, el que deberá ser firmado en original, por responsable financiero y el alumno, y entregarlo en nuestras oficinas de Matrículas ubicadas en la Universidad con plazo 27 de abril.</p>
                                                    <p style={{ textAlign: 'left' }}> <b>Sede Santiago:</b> Av. Plaza 680, Las Condes, Edificio O piso -1<br />
                                                        <b>Sede Concepción:</b> Ainavillo 455, Concepción   <br /> <br /></p>
                                                    <p><a style={{ fontWeight: 'bold', color: '#2121dc', cursor: 'pointer' }} onClick={handleVisualizarContratoConFirma}><u>Descargar contrato</u></a></p>
                                                </div>}
                                        </div>
                                    </DialogContent>
                                    <DialogActions>
                                        <Button autoFocus onClick={() => {
                                            setOpenRespuesta(false)
                                        }} color="primary" >Salir</Button>
                                    </DialogActions>
                                </Dialog>
                                <Dialog open={errorVentanasEmergentes}
                                    maxWidth={"xl"}
                                    aria-labelledby="draggable-dialog-title">
                                    <DialogContent>
                                        <div style={{ fontFamily: 'sans-serif', textAlign: 'center' }}>
                                            {
                                                <div style={{ textAlign: 'center', padding: 20 }}>
                                                    <ErrorOutlineRounded style={{ fontSize: 100, color: 'red' }} />
                                                    <br />
                                                    <br />
                                                    <h4><span>Ventanas emergentes bloqueadas.</span></h4>
                                                    <br />
                                                    <a href="https://support.google.com/chrome/answer/95472?hl=es&co=GENIE.Platform%3DDesktop&oco=0" target="_blank">¿ Como resolverlo ?</a>
                                                </div>
                                            }
                                        </div>
                                    </DialogContent>
                                    <DialogActions>
                                        <Button autoFocus onClick={() => {
                                            window.location.reload()
                                        }} color="primary" >Salir</Button>
                                    </DialogActions>
                                </Dialog>
                                <Dialog open={errorEtapas}
                                    maxWidth={"xl"}
                                    aria-labelledby="draggable-dialog-title">
                                    <DialogContent>
                                        <div style={{ fontFamily: 'sans-serif', textAlign: 'center' }}>
                                            {
                                                <div style={{ textAlign: 'center', padding: 20 }}>
                                                    <ErrorOutlineRounded style={{ fontSize: 100, color: 'red' }} />
                                                    <br />
                                                    <a><span>Ocurrió un problema al intentar validar su identidad, favor comunicarse con la universidad.</span></a>
                                                    <br />
                                                </div>
                                            }
                                        </div>
                                    </DialogContent>
                                    <DialogActions>
                                        <Button autoFocus onClick={() => {
                                            setErrorEtapas(false)
                                        }} color="primary" >Salir</Button>
                                    </DialogActions>
                                </Dialog>


                                <Dialog open={mnsjeCert}
                                    onClose={() => setMnsjeCert(false)}
                                    aria-labelledby="draggable-dialog-title">
                                    <DialogContent>
                                        <div style={{ fontFamily: 'sans-serif', textAlign: 'center' }}>
                                            <div style={{ textAlign: 'center' }}>

                                                <CheckCircleOutline style={{ fontSize: 100, color: '#0062a1' }} />
                                                <br />
                                                <h1><span>Importante</span></h1>
                                                <h3><span>{con.mensajeeCert()}</span></h3>

                                            </div>
                                        </div>
                                    </DialogContent>
                                    <DialogActions>
                                        <Button autoFocus onClick={() => {
                                            setMnsjeCert(false)
                                        }} color="primary" >Salir</Button>
                                    </DialogActions>
                                </Dialog>
                            </div>
                        </>
            }
            {
                openModalToken.open ?
                    <MensajeToken mnsj={openModalToken.mnsj} codNegocio={codNegocio}></MensajeToken>
                    :
                    ""
            }
        </>
    )
}

export default OnlyFirmaContrato;
